module.exports = __webpack_public_path__ + "web/img/speech2.d2effbd6.png";